import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import the CSS file with fonts
import App from './App';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import maintenanceService from './services/MaintenanceService';

// Start maintenance watcher globally so every page receives maintenance events
maintenanceService.onUpdate((data) => {
  try {
    window.dispatchEvent(new CustomEvent('maintenance:update', { detail: data }));
  } catch (e) {
    // ignore
  }
});
maintenanceService.start();
window.addEventListener('beforeunload', () => maintenanceService.stop());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
